var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.768,
    height: 10,
    viewBox: "0 0 21.768 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6030",
    "data-name": "Grupo 6030",
    transform: "translate(-131.104 7039.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-reorder",
    "data-name": "Icon ionic-ios-reorder",
    transform: "translate(137.119 -7038.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7152",
    "data-name": "Trazado 7152",
    d: "M5.625,21.375h9.738V22.5H5.625Z",
    transform: "translate(-5.625 -13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7153",
    "data-name": "Trazado 7153",
    d: "M5.625,17.438h9.738v1.125H5.625Z",
    transform: "translate(-5.625 -13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7154",
    "data-name": "Trazado 7154",
    d: "M5.625,13.5h9.738v1.125H5.625Z",
    transform: "translate(-5.625 -13.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-up",
    "data-name": "Icon awesome-long-arrow-alt-up",
    d: "M2.809,5.216V11.9a.266.266,0,0,0,.265.265H4.314a.266.266,0,0,0,.265-.265V5.216H5.6a.531.531,0,0,0,.375-.906l-1.9-1.9a.531.531,0,0,0-.751,0l-1.9,1.9a.531.531,0,0,0,.375.906Z",
    transform: "translate(146.742 -7041.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-up-2",
    "data-name": "Icon awesome-long-arrow-alt-up",
    d: "M2.809,9.2V2.515a.266.266,0,0,1,.265-.265H4.314a.266.266,0,0,1,.265.265V9.2H5.6a.531.531,0,0,1,.375.906l-1.9,1.9a.531.531,0,0,1-.751,0l-1.9-1.9A.531.531,0,0,1,1.79,9.2Z",
    transform: "translate(129.846 -7041.503)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragable);
export default __webpack_public_path__ + "static/media/Dragable.99082e17d6eaab3dd08633f70af0b244.svg";
export { ForwardRef as ReactComponent };